@for (ans of answers; track ans) {
  <div>
    <appform-dropdown-input
      (onControlValueChanges)="onValueChanges($event)"
      [readOnly]="readOnly"
      [choice_id]="ans.choice_id"
      [choice_ids]="ans.choice_ids"
      [question_id]="ans.question.id"
      [answer_id]="ans.id"
      [code]="ans.question.code"
      [fieldType]="ans.question.field_type"
      [label]="ans.question.text"
      [choices]="ans.question.choices"
      [multiple]="ans.question.multiple"
      [useAlias]="false"
      [error_text]="ans.question.error_text"
      [help_text]="ans.question.help_text"
      [required]="ans.question.required"
      [placeholder]="ans.question.placeholder"
    ></appform-dropdown-input>
  </div>
}
